import * as React from 'react';
import { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    CircularProgress
} from '@mui/material';
import axios from 'axios';

export default function FinishPlanDialog({ open, onClose, token, onSuccess, insurer, planName, planUID }) {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!planUID) {
            setError("Plan-ID fehlt.");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            await axios.post(
                `/admin/api/v1/users/plans/${planUID}/cancel`,
                {},
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            onSuccess();
            onClose();
        } catch (error) {
            console.error('Error finishing plan:', error);
            setError(`Fehler beim Beenden des Plans "${planUID}". Bitte versuchen Sie es erneut.`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                component: 'form',
                onSubmit: (event) => {
                    event.preventDefault();
                    handleSubmit();
                },
            }}
        >
            <DialogTitle><b>Plan beenden</b></DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Sie sind dabei, den Plan des Benutzers zu beenden.
                    <br />
                    Möchten Sie wirklich mit dem Vorgang fortfahren? <b>"{insurer}, {planName}"</b>?
                </DialogContentText>
                <br />
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Abbrechen</Button>
                <Button type="submit" color="error" disabled={loading || !planUID}>
                    {loading ? <CircularProgress size={24} /> : 'Beenden'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}